// Dutch translations
export const nl = {
  // Common
  common: {
    home: 'Home',
    settings: 'Instellingen',
    language: 'Taal',
    loading: 'Laden...',
    save: 'Opslaan',
    cancel: 'Annuleren',
    confirm: 'Bevestigen',
    close: 'Sluiten',
    back: 'Back',
    continue: 'Continue',
    accept: 'Accept',
    decline: 'Decline',
    contactEmail: 'contact@zodiac-chess.com',
    companyName: 'Animal Chess Limited',
    companyCountry: 'New Zealand',
  },

  // Settings Menu
  settings: {
    header: 'Instellingen',
    home: 'Home',
    howToPlay: 'Hoe te spelen',
    pieceRules: 'Stukregels',
    language: 'Taal',
    manageSubscription: 'Abonnement beheren',
    gameHistory: 'Spelgeschiedenis',
    analytics: 'Analytics',
    premiumAccount: 'Premium account',
    chatEnabled: 'Chat: Aan',
    chatDisabled: 'Chat: Uit',
  },

  // Piece Rules
  pieceRules: {
    title: 'Stukregels',
    description: 'Leer de stukbewegingen',
    selectPiece: 'Selecteer stuk',
    selectedLabel: 'Geselecteerd:',
    statusLabel: 'Status:',
    statusReady: 'Klaar',
    statusViewing: 'Bekijken',
    movement: 'Beweging',
    regularMovement: 'Reguliere beweging',
    ability: 'Vermogen',
      backToSelection: 'Back to selection',
    backToHome: 'Back to home',
  },

  // Move/Ability Names
  moves: {
    movement: 'Beweging',
    savage: 'Wild',
    birdtype: 'Vogeltype',
    birdType: 'Vogeltype',
    wallBlock: 'Muurblok',
    moveblocks: 'Bewegingsblokken',
    wallclimb: 'Muurklimmen',
    lilypad: 'Waterlelie',
    poisonous: 'Giftig',
    meadow: 'Weide',
    parasiticfungi: 'Parasitaire schimmel',
    zombification: 'Zombificatie',
    fungi: 'Schimmel',
    traverse: 'Doorkruisen',
    capture: 'Slaan',
    faint: 'Flauwvallen',
    leap: 'Springen',
    swing: 'Zwaaien',
    consume: 'Consumeren',
    gamble: 'Gokken',
    entangle: 'Verstrengelen',
    ink: 'Inkt',
    rotate: 'Roteren',
    backstep: 'Achterwaarts',
    trample: 'Vertrappen',
    charge: 'Stormaanval',
    lane: 'Baan',
    snakestrike: 'Slangenslag',
    shedskin: 'Vervellen',
    house: 'Huis',
    plant: 'Planttype',
    planttype: 'Planttype',
    capturehost: 'Gastheer slaan',
    contagion: 'Besmetting',
    lonewolf: 'Eenzame wolf',
    hop: 'Huppelen',
    decay: 'Verval',
    slide: 'Glijden',
    block: 'Blokkeren',
    poison: 'Gif',
    infection: 'Infectie',
    howl: 'Huilen',
  },

  // Animation Scenario Descriptions
  scenarios: {
    // Bear
    bearMovement: 'De beer kan één veld in elke richting bewegen, zoals een koning in schaken',
    bearMovementPost: 'Het wordt alleen geblokkeerd door vriendelijke stukken (behalve bomen, beren kunnen in bomen klimmen!)',
    bearSavage: 'Een beer kan defensieve vermogens zoals het Neushoornblok overwinnen',
    bearSavagePost: 'Door Wild te gebruiken kan de beer elk stuk uit elke richting slaan, wat dodelijkheid toevoegt',

    // Crane
    craneMovement: 'De kraanvogel kan 1 of 2 velden in een rechte lijn bewegen',
    craneMovementPost: 'De kraanvogel kan zelfs over andere stukken heen vliegen!',
    craneBirdType: 'Vogeltypestukken kunnen geen grote of roofdierenstukken slaan',
    craneBirdTypePost: 'Dit omvat Boom, Neushoorn, Beer en Wolf',

    // Frog
    frogMovement: 'De kikker springt 2 velden diagonaal',
    frogMovementPost: 'Hij kan niet slechts één springen',
    frogWallBlock: 'Als het reguliere 2-veldenpad van de kikker wordt geblokkeerd door een muur of ander stuk, kan hij niet slaan',
    frogWallBlockPost: 'Zijn reguliere beweging wordt verkort tot 1 veld diagonaal',
    frogWallClimb: 'Wanneer de kikker op de bordrand is (kolom A of E), kan hij één veld omhoog of omlaag bewegen',
    frogWallClimbPost: 'Tenzij geblokkeerd door een vriendelijk stuk of een neushoorn voor de kikker',
    frogLilypad: 'Als de kikker nog niet heeft bewogen in een spel, kan hij naar een van de eerste 3 rijen springen als een krachtig defensief vermogen',
    frogLilypadPost: 'Hij kan elk regulier stuk slaan met Waterleliesprong, behalve een neushoorn op een hogere rij dan zichzelf',
    frogPoisonous: 'Wanneer een dier een kikkerstuk slaat, word je vergiftigd!',
    frogPoisonousPost: 'Een vergiftigd stuk slaat zijn volgende beschikbare beurt over voordat het herstelt',

    // Fungi
    fungiMovement: 'De schimmel kan één veld in elke richting bewegen',
    fungiMovementPost: 'Hij wordt alleen geblokkeerd door bondgenootsstukken',
    fungiMeadow: 'De schimmel vermindert het bewegingsvermogen van het vijandelijke boomstuk',
    fungiMeadowPost: 'Het vijandelijke boomstuk kan niet binnen 1 veld van het schimmelstuk bewegen',
    fungiParasitic: 'De schimmel kan het vijandelijke boomstuk immobiliseren',
    fungiParasiticPost: 'Als de schimmel binnen 1 veld van de vijandelijke boom is, kan hij niet bewegen totdat de schimmel wegbeweegt of wordt geslagen',
    fungiZombification: 'De schimmel kan elk vijandelijk dierenstuk dat hem slaat zombificeren, waardoor controle over het vijandelijke dier voor één beurt wordt verkregen',
    fungiZombificationPost: 'Het gezombificeerde stuk wordt ook beschouwd als het schimmelstuk voor die beurt, zelfs als de schimmel je koning was eindigt het spel pas na die beurt',
    fungiFungi: 'Paddenstoel',
    fungiFungiPost: 'Zoals gif, verstrengeling en virusinfectie, maar niet zombificatie omdat hij anderen kan zombificeren!',

    // Goat
    goatMovement: 'De geit kan één veld in elke richting bewegen',
    goatMovementPost: 'De geit beweegt langzaam maar heeft krachtige vermogens',
    goatTraverse: 'De geit kan over alle andere verbonden stukken doorkruisen om massaal bewegingspotentieel te creëren',
    goatTraversePost: 'De geit kan niet over flauwgevallen geiten of kleine stukken zoals virus doorkruisen',
    goatCapture: 'De geit kan geen roofdieren slaan',
    goatCapturePost: 'Zoals beer of wolf',
    goatFaint: 'De geit kan flauwvallen om geslagen worden te vermijden behalve door grote stukken zoals boom en neushoorn',
    goatFaintPost: 'Tijdens flauwvallen kunnen tegenstanders op de flauwgevallen geit "staan" om zijn beweging te stoppen',

    // Monkey
    monkeyMovement: 'De aap kan één veld in elke richting bewegen',
    monkeyMovementPost: 'Zonder andere stukken om te gebruiken heeft de aap beperkte beweging',
    monkeyLeap: 'De aap kan, zoals dammen, over andere stukken in een rechte lijn springen voor enorm bewegingspotentieel',
    monkeyLeapPost: 'Maar als hij over een vijandelijk stuk springt, moet de aap een dobbelsteen gooien om de sprong te overleven, 1/6 kans om geslagen te worden voor elke vijand waar hij overheen springt!',
    monkeySwing: 'Als een aap een sprong over een boom gebruikt, krijgt de aap een bonusbeurt',
    monkeySwingPost: 'Het gebruik van boomzwaai creëert een krachtige synergistische combo tussen de aap en het boomstuk',
    monkeyConsume: 'De aap kan een schimmel consumeren voor een bonusbeurt',
    monkeyConsumePost: 'Wat leidt tot verwoestende combinaties wanneer gecombineerd met andere bonusbeurten',
    monkeyGamble: 'Naast het gooien van een dobbelsteen om over vijanden te springen, moet de aap gokken om de beer te slaan',
    monkeyGamblePost: 'De aap moet een 5 of 6 gooien op een 6-zijdige dobbelsteen om de beer te slaan of wordt zelf geslagen',

    // Octopus
    octopusMovement: 'De octopus beweegt één veld in elke richting',
    octopusCapture: 'De octopus kan alleen orthogonaal slaan',
    octopusCapturePost: 'De octopus kan stukken op complexe manieren slaan of verstrengelen, dus controleer altijd op rode slagen en paarse verstrengelingen!',
    octopusEntangle: 'De octopus kan aangrenzende vijandelijke stukken verstrengelen en immobiliseren, hij kan zelfs een veld bewegen en vijanden verstrengelen!',
    octopusEntanglePost: 'Verstrengelde stukken kunnen niet bewegen totdat de octopus wegbeweegt of wordt geslagen',
    octopusInk: 'De octopus kan inkt gebruiken om aan gevaarlijke situaties te ontsnappen en tot 3 schaduwen te creëren',
    octopusInkPost: 'De vijand verwarren en interessante lok- en ontwijkende spellen mogelijk maken',

    // Penguin
    penguinMovement: 'De pinguïn glijdt in een rechte lijn in zijn ingestelde richting totdat een muur of stuk zijn beweging blokkeert',
    penguinMovementPost: 'Na het bewegen kan de pinguïn binnen dezelfde beurt ook zijn eindrichting instellen',
    penguinRotate: 'Aan het begin van de wedstrijd kijkt een pinguïn naar beneden en moet roteren voordat hij kan glijden, ook wel slapend genoemd',
    penguinRotatePost: 'De pinguïn kan in elke positie kiezen om te roteren in plaats van te bewegen',
    penguinBirdType: 'De pinguïn heeft beperkte slagvermogens, zoals de kraanvogel kan hij geen grote of roofdierenstukken zoals boom, neushoorn, beer of wolf slaan',
    penguinBirdTypePost: 'Na het slaan kan de pinguïn roteren om elke richting op te kijken voor strategische positionering',

    // Rhino
    rhinoMovement: 'De neushoorn beweegt twee velden alleen vooruit',
    rhinoMovementPost: 'Hij kan niet slechts 1 veld bewegen',
    rhinoBackStep: 'De neushoorn kan achter-links of achter-rechts bewegen',
    rhinoCharge: 'De neushoorn kan eenmaal per spel een extra veld vooruit reizen met zijn stormaanval-vermogen',
    rhinoChargePost: 'Wat leidt tot verwoestend bewegings- en slagpotentieel',
    rhinoTrample: 'De neushoorn slaat alle stukken in zijn reispad met Vertrappen',
    rhinoTramplePost: 'Inclusief een flauwgevallen geitenstuk',
    rhinoLane: 'De neushoorn kan van plaats wisselen met een ander bondgenootsstuk wat strategisch banenspel mogelijk maakt',
    rhinoLanePost: 'Maar alleen als de neushoorn en het bondgenootsstuk beide niet hebben bewogen',

    // Snake
    snakeMovement: 'De slang kan 2 velden in elke rechte lijn bewegen',
    snakeMovementPost: 'De slang beweegt precies 2 velden tenzij geblokkeerd door een muur of vriendelijk stuk',
    snakeMoveBlocks: 'Wanneer geblokkeerd door een muur of stuk dat hij niet kan slaan, wordt de beweging van de slang verkort tot 1 veld',
    snakeMoveBlocksPost: 'Hij kan nog steeds twee velden bewegen zelfs als er een tussenliggend stuk is',
    snakeStrike: 'De slang kan 3 velden vooruit slaan als er een vijandelijk dier is',
    snakeStrikePost: 'Zolang geen tussenliggende stukken zijn pad blokkeren',
    snakeShedskin: 'Eenmaal per spel kan de slang vervellen en terugkeren naar de eerste rij als het veld vrij is',
    snakeShedskinPost: 'Deze wedergeboorte geeft de slang een extra leven elk spel',

    // Tree
    treeMovement: 'De boom kan één veld vooruit of naar elk veld op zijn rij van links naar rechts bewegen',
    treeMovementPost: 'Zolang zijn pad niet is geblokkeerd',
    treeHouse: 'De boom kan andere stukken huisvesten en beschermen tegen vijanden die niet in bomen kunnen klimmen. Misschien kunnen stukken klimmen zoals beer, kraanvogel, kikker, schimmel, geit, aap, octopus en slang',
    treeHousePost: 'Wanneer een stuk dat in een boom kan klimmen aanvalt, slaat het alleen het gehuisveste stuk en beschermt de boom',
    treeTrample: 'De boom slaat, zoals de neushoorn, alle stukken in een veld wanneer hij beweegt',
    treeTramplePost: 'Dit omvat een flauwgevallen geit',
    treePlant: 'De boom is een plant, geen dier dus hij is immuun voor verschillende effecten',
    treePlantPost: 'Zoals gif, zombificatie, verstrengeling en virusinfectie!',

    // Virus
    virusMovement: 'Het virus kan alleen naar velden bezet door dieren bewegen die twee velden verderop zijn',
    virusMoveBlocks: 'Het virus kan slechts één veld bewegen als het naast een muur is',
    virusCaptureHost: 'Wanneer het virus landt op (in) een dierenstuk, infecteert het ze alleen, ze kunnen nog steeds normaal spelen terwijl ze geïnfecteerd zijn',
    virusCaptureHostPost: 'Het virus slaat het stuk pas wanneer het de geïnfecteerde gastheer verlaat',
    virusContagion: 'Het virus kan snel verspreiden door meerdere gastheren in één beurt te infecteren',
    virusContagionPost: 'Besmetting stelt het virus in staat om zoveel legale zetten te doen als het wil elke beurt',

    // Wolf
    wolfMovement: 'De wolf kan in een L-vorm bewegen, zoals het paard in schaken',
    wolfMovementPost: 'Hij wordt niet geblokkeerd door andere stukken',
    wolfLoneWolf: 'Wolf',
    wolfLoneWolfPost: 'De wolf beschouwt zichzelf ook als eenzaam wanneer hij nog een flauwgevallen geit of een virusbondgenoot heeft',
  },

  // Tutorials
  tutorials: {
    dragToExploreMobile: '👆 Sleep om te verkennen • Knijp om te zoomen',
    dragToExploreDesktop: '🖱️ Sleep om te verkennen • Scroll om te zoomen',
    previousConstellation: 'Previous constellation',
    nextConstellation: 'Next constellation',
    lockedNextHint: 'Complete at least 3 {constellation} tutorials to move to the next constellation',
    lockedStateLabel: 'Star Path',
    freeStateLabel: 'Free Roam',
    clickToFreeRoam: 'Click to free roam',
    clickForStarPath: 'Click for Star Path',
    // Tutorial popups
    failed: 'FAILED!',
    success: 'SUCCESS!',
    failedDefaultMessage: "Don't give up! Try a different approach.",
    superMessage: 'Perfect! You achieved Super completion!',
    passMessage: 'Well done! Tutorial completed!',
    tryAgain: 'Try Again',
    back: 'Terug',
    next: 'Volgende',
    backToDev: 'Back to Dev',
    backToTutorials: 'Back to Tutorials',
    continue: 'Continue',
    close: 'Close',
  },

  // Sandbox
  sandbox: {
    title: 'ZANDBAK',
    description: 'Experimenteer & Oefen',
    mode: 'Modus:',
    modeValue: 'Zandbak',
    status: 'Status:',
    statusReady: 'Klaar',
    clearBoard: 'Bord leegmaken',
  },

  // Multiplayer
  multiplayer: {
    title: 'MULTIPLAYER',
    description: 'Vind je match en strijd!',
    // Rematch
    rematchRequest: 'Rematch Request',
    rematchMessage: '{opponent} wants to play again!',

    // Placement matches
    placementMatches: 'Plaatsingswedstrijden',
    matchProgress: 'Wedstrijdvoortgang',
    gamesCompleted: '{games} / 10 Spellen Voltooid',
    estimatedFinalRating: 'Geschatte eindrating',
    startingRating: 'Startrating',
    matchesRemaining: '{matches} wedstrijden resterend',
    findPlacementMatch: 'Vind plaatsingswedstrijd',

    // Matchmaking modes
    findMatch: 'Vind wedstrijd',
    competitive: 'Competitief',
    competitiveDesc: 'Vind tegenstanders dichtbij je ranking',
    quick: 'Snel',
    quickDesc: 'Vind competitieve wedstrijden snel',
    casual: 'Casual',
    casualDesc: 'Unranked - speel voor de lol!',
    placement: 'Plaatsing',
    placementDesc: 'Voltooi 10 wedstrijden om een rang te krijgen',
    startSearch: 'Start zoeken',

    // Searching
    searching: 'Zoeken...',
    mode: 'Modus:',
    inQueue: 'In wachtrij:',
    players: 'speler',
    playersPlural: 'spelers',
    cancelSearch: 'Zoeken annuleren',

    // Game info
    status: 'Status:',
    ready: 'Klaar',
    selectingKing: 'Koning selecteren',
    placingPieces: 'Stukken plaatsen',
    playing: 'Spelen',
    gameType: 'Speltype:',
    opponent: 'Tegenstander:',
    opponentElo: 'Tegenstander ELO:',
    unranked: 'Unranked',

    // Piece placement
    dragPieces: 'Sleep stukken naar het bord',
    lightPieces: 'Lichte stukken (Jij)',
    darkPieces: 'Donkere stukken (Jij)',

    // Waiting states
    waitingForOpponent: 'Wachten op tegenstander...',
    waitingForKing: 'Wachten tot tegenstander zijn koning selecteert...',

    // Warnings
    invalidPlacement: 'Ongeldige plaatsing',
    lightTurn: 'Het is de beurt van lichte speler!',
    darkTurn: 'Het is de beurt van donkere speler!',
    onlyLightPieces: 'Je kunt alleen lichte stukken plaatsen!',
    onlyDarkPieces: 'Je kunt alleen donkere stukken plaatsen!',
    mustPlaceOnRow: '{color} stukken moeten op rij {row} worden geplaatst!',

    // Chat
    chat: 'Chat',
    typeMessage: 'Typ een bericht...',
    send: 'Verzenden',
  },

  // Main Page
  mainPage: {
    title: 'DIERENSCHAAK',
    subtitle: 'Een spel voor mensen',
    playersOnline: 'Huidige spelers online',
    placement: 'Plaatsing',
    placementProgress: 'Plaatsing',
    challengeAI: 'Daag AI uit',
    multiplayer: 'Multiplayer',
    sandbox: 'Zandbak',
    tutorials: 'Tutorials',
    shop: 'Winkel',
    collection: 'Collectie',
    history: 'Geschiedenis',
    analytics: 'Analytics',
    courses: 'Cursussen',
    upgradeAccount: 'Account upgraden',
    signIn: 'Inloggen',
    playAsGuest: 'Speel als gast',
    welcomeBack: 'Welkom terug! Je speelt meestal als',

    // Learn the Pieces section
    learnThePieces: 'Leer de stukken',

    // Learn the Rules section
    learnTheRules: 'Leer de regels',
    premiseTitle: 'Premisse',
    premiseText: 'Zodiac is een schaakalternatief met een VERBORGEN koning uit een roster van 13 stukken, selecteer een uniek roster en bluf dan je tegenstander om hen te verslaan op een 5 bij 8 bord',
    selectionTitle: 'Selectie',
    selectionText: 'Om een spel te starten, kies geheim je koning, plaats dan je 5 stukken afwisselend met je tegenstander om een van meer dan 500 miljard begintoestanden te creëren.',
    objectiveTitle: 'Doelstelling',
    objectiveText: 'Lees je tegenstander om hun geheime koning te SLAAN of RACE je koning over het bord om de overwinning veilig te stellen!',
    competeTitle: 'Strijd',
    competeText: 'Test je vaardigheden op de ladder, ontwikkel nieuwe persoonlijke technieken en strategieën, rank omhoog om het tegen de besten op te nemen!',
    fullRulesButton: 'Voor volledige officiële regels klik hier',

    // FAQ section
    faqTitle: 'Veelgestelde vragen',
    faqQuestion1: 'Wat is het idee achter Zodiac schaak?',
    faqAnswer1: 'Zodiac schaak was aanvankelijk geïnspireerd door woorden van Bobby Fischer over zijn inspiratie om Chess960 te maken, we wilden uitbreiden op het idee van het bestrijden van mechanisch memoriseren en het vieren van menselijke intuïtie in ondenkbare diepte!',
    faqQuestion2: 'Waarom hebben we een schaakalternatief nodig',
    faqAnswer2: 'Dat hoeft niet! Zodiac wil mensen niet weghouden van schaken! Het is een andere optie met zijn eigen sterke en zwakke punten, we hopen dat je er plezier aan beleeft en ons helpt dit spel aan te passen om nieuw spel te verlevendigen',
    faqQuestion3: 'Hoe win je in Zodiac schaak?',
    faqAnswer3: 'Er zijn drie manieren om te winnen: sla het verborgen koningsstuk van je tegenstander, race je eigen koning naar de andere kant van het bord, of in een wedstrijd met tijdcontroles, laat de tijd van je tegenstander aflopen',
    faqQuestion4: 'Is dit een FAQ?',
    faqAnswer4: 'Ja, je kunt naar een van de vermelde vragen in de FAQ kijken en als je wat meer details wilt, kun je op de vragen klikken en dan de volgende details lezen, zoals deze details die je nu leest',
    faqQuestion5: 'Hoe lang duurt een typisch spel?',
    faqAnswer5: 'Elk spel verschilt enorm! Sommige spellen zijn voorbij in 2 zetten en sommige kunnen 30 minuten duren, we merken meestal dat ze in het 5-15 minuten bereik liggen!',
    faqQuestion6: 'Wat gebeurt er als niemand een legale zet kan doen?',
    faqAnswer6: 'Als een speler geen legale zet kan doen (pat), eindigt het spel in remise. Het spel kan ook eindigen in remise door herhaling (zelfde bordstatus 3 keer) of door wederzijdse overeenstemming tussen spelers!',

    // About section
    aboutButton: 'Over',
    privacyPolicy: 'Privacybeleid',
    developerInterface: 'Ontwikkelaarsinterface',
  },

  // About Modal
  about: {
    title: 'Over Zodiac',
    paragraph1: 'Zodiac is een schaakachtig bordspel dat elementen van stukkeuze uit spellen zoals LoL en DotA combineert, met blufmechanismen uit poker of sociale deductiespellen.',
    paragraph2: 'Vroege versies van het spel werden in 2014 gemaakt, onder de naam Shadow Chess. In 2018 werd het opnieuw ontworpen tot wat je vandaag ziet, met een roster van leuke stukken met gebalanceerde maar unieke bewegingspatronen en vermogens.',
    paragraph3: 'Onze visie is om alle gebruikersgameplaygegevens op te nemen om het spel te blijven ontwikkelen in een poging om gameplay verfrissend te houden en nieuwe spellen aan te moedigen.',
    paragraph4: 'Met Zodiacs gigantische zoekruimte, verborgen informatie en openende bordposities hopen we AI-dominantie af te weren en zodiac een spel voor mensen te houden!',
  },

  // Privacy Policy
  privacy: {
    title: 'Privacybeleid',
    lastUpdated: 'Laatst bijgewerkt',

    introduction: {
      title: 'Introductie',
      p1: 'Welkom bij Zodiac Chess ("wij", "ons" of "onze"). We zijn toegewijd aan het beschermen van je privacy en zorgen ervoor dat je een veilige en plezierige spelervaring hebt. Dit privacybeleid legt uit hoe we je informatie verzamelen, gebruiken, openbaar maken en beschermen wanneer je onze website en ons spel gebruikt.',
      p2: 'Door Zodiac Chess te gebruiken, stem je in met het verzamelen en gebruiken van informatie in overeenstemming met dit beleid. Als je niet akkoord gaat met ons beleid en onze praktijken, gebruik dan onze service niet.',
      contact: 'Neem contact met ons op:',
    },

    infoCollect: {
      title: 'Informatie die we verzamelen',
      accountInfo: {
        title: '1. Accountinformatie',
        item1: 'E-mailadres: Vereist voor het aanmaken van een account en communicatie',
        item2: 'Gebruikersnaam: Je gekozen weergavenaam',
        item3: 'Wachtwoord: Versleuteld en veilig opgeslagen',
      },
      gameData: {
        title: '2. Spelgegevens',
        item1: 'Spelstatistieken: Overwinningen, nederlagen, ELO-rating, plaatsingswedstrijdvoortgang',
        item2: 'Gameplaygegevens: Stukkeuzes, gemaakte zetten, gebruikte strategieën',
        item3: 'Wedstrijdgeschiedenis: Records van gespeelde spellen, geconfronteerde tegenstanders',
        item4: 'In-game aankopen: Cosmetische items en premium lidmaatschapsstatus',
      },
      technicalData: {
        title: '3. Technische gegevens',
        item1: 'Apparaatinformatie: Browsertype, besturingssysteem',
        item2: 'Gebruiksgegevens: Bezochte pagina\'s, bestede tijd, gebruikte functies',
        item3: 'Lokale opslag: Taalvoorkeuren, UI-instellingen, tijdelijke spelstatus',
      },
    },

    children: {
      title: 'Privacy van kinderen (COPPA-naleving)',
      p1: 'Zodiac Chess is ontworpen om gezinsvriendelijk en geschikt te zijn voor spelers van alle leeftijden, inclusief kinderen. We nemen speciale zorg om te voldoen aan de Children\'s Online Privacy Protection Act (COPPA).',
      p2: 'Voor gebruikers onder de 13 jaar: We raden aan dat kinderen onze gastspelmodus gebruiken, die geen account aanmaken of gegevensverzameling vereist. Gastaccounts hebben geen toegang tot tekstchatfuncties, wat ervoor zorgt dat kinderen niet worden blootgesteld aan communicatie met het bredere internet. Als een kind een account aanmaakt, vereisen we ouderlijke toestemming voordat we persoonlijke informatie verzamelen.',
      p3: 'We verzamelen, gebruiken of delen NIET bewust persoonlijke informatie van kinderen onder de 13 jaar zonder geverifieerde ouderlijke toestemming.',
      p4: 'Chatveiligheid: Tekstchat is automatisch uitgeschakeld voor alle gast-/tijdelijke accounts. Standaardaccounthouders hebben de optie om chatfunctionaliteit in hun accountinstellingen op elk moment uit te schakelen.',
      parentalRights: 'Ouders hebben het recht om:',
      right1: 'De persoonlijke informatie van hun kind te bekijken',
      right2: 'Verwijdering van de gegevens van hun kind te vragen',
      right3: 'Verdere verzameling of gebruik van de informatie van hun kind te weigeren',
      contactUs: 'Om deze rechten uit te oefenen of als je denkt dat je kind ons persoonlijke informatie heeft verstrekt, neem dan onmiddellijk contact met ons op via contact@zodiac-chess.com',
    },

    howWeUse: {
      title: 'Hoe we je informatie gebruiken',
      item1: 'Onze speldiensten leveren en verbeteren',
      item2: 'Je matchen met geschikte tegenstanders op basis van vaardigheidsniveau',
      item3: 'Je voortgang, statistieken en prestaties bijhouden',
      item4: 'Betalingen verwerken voor premium lidmaatschappen en cosmetische items',
      item5: 'Belangrijke service-aankondigingen en updates verzenden',
      item6: 'Gameplaygegevens analyseren om spelbalans en functies te verbeteren',
    },

    thirdParty: {
      title: 'Diensten van derden',
      firebase: {
        title: 'Firebase (Google)',
        description: 'We gebruiken Firebase voor authenticatie, database-opslag en multiplayerfunctionaliteit. Firebase kan bepaalde gegevens verzamelen zoals beschreven in hun privacybeleid.',
      },
      stripe: {
        title: 'Stripe',
        description: 'We gebruiken Stripe om betalingen te verwerken voor premium lidmaatschappen en in-app aankopen. Stripe behandelt alle betaalkaardinformatie - we zien of slaan je volledige betalingsgegevens nooit op.',
      },
      netlify: {
        title: 'Netlify',
        description: 'Onze website wordt gehost op Netlify, die standaard webhostinggegevens zoals IP-adressen en toegangslogboeken kan verzamelen.',
      },
      adsense: {
        title: 'Google AdSense (Toekomst)',
        description: 'We kunnen advertenties weergeven via Google AdSense. Deze advertenties kunnen cookies gebruiken voor personalisatie. Voor op kinderen gerichte inhoud zullen we alleen niet-gepersonaliseerde advertenties weergeven in overeenstemming met COPPA.',
      },
      viewPolicy: 'Bekijk hun privacybeleid',
    },

    cookies: {
      title: 'Cookies en lokale opslag',
      description: 'We gebruiken lokale browseropslag (vergelijkbaar met cookies) om je ervaring te verbeteren:',
      item1: 'Taalvoorkeur: Onthoud je geselecteerde taal',
      item2: 'Accountsessie: Houd je ingelogd (werkt met Firebase)',
      item3: 'Spelinstellingen: Onthoud je UI-voorkeuren en zandbakopstellingen',
      item4: 'Advertentiecookies: Als je toestemming geeft, kunnen advertentiediensten van derden cookies gebruiken voor advertentiepersonalisatie',
    },

    security: {
      title: 'Gegevensbeveiliging',
      p1: 'We implementeren passende beveiligingsmaatregelen om je informatie te beschermen:',
      item1: 'Wachtwoordversleuteling: Alle wachtwoorden worden versleuteld met industriestandaardmethoden',
      item2: 'Veilige verbindingen: HTTPS-versleuteling voor alle gegevensoverdracht',
      item3: 'Firebase-beveiligingsregels: Strikte database-toegangscontroles',
      p2: 'Geen enkele methode van overdracht via internet is echter 100% veilig. Hoewel we streven naar het beschermen van je gegevens, kunnen we absolute beveiliging niet garanderen.',
    },

    retention: {
      title: 'Gegevensbehoud',
      p1: 'We bewaren je gegevens als volgt:',
      item1: 'Actieve accounts: Gegevens worden bewaard terwijl je account actief is',
      item2: 'Inactieve accounts: Als je account 10 jaar inactief is, kunnen we je gegevens verwijderen',
    },

    rights: {
      title: 'Je privacyrechten',
      description: 'Afhankelijk van je locatie kun je de volgende rechten hebben:',
      access: {
        title: 'Toegang:',
        description: 'Vraag een kopie van je persoonlijke gegevens aan',
      },
      correction: {
        title: 'Correctie:',
        description: 'Vraag correcties van je gegevens aan',
      },
      deletion: {
        title: 'Verwijdering:',
        description: 'Vraag verwijdering van je account en gegevens aan',
      },
      portability: {
        title: 'Gegevensportabiliteit:',
        description: 'Vraag je gegevens aan in een overdraagbaar formaat',
      },
      optOut: {
        title: 'Opt-out:',
        description: 'Opt-out voor marketingcommunicatie',
      },
      contact: 'Om een van deze rechten uit te oefenen, neem contact met ons op via contact@zodiac-chess.com',
    },

    international: {
      title: 'Internationale gebruikers',
      p1: 'Zodiac Chess wordt beheerd vanuit Nieuw-Zeeland. Als je toegang hebt tot onze service van buiten Nieuw-Zeeland, houd er dan rekening mee dat je informatie kan worden overgedragen naar, opgeslagen en verwerkt in Nieuw-Zeeland en andere landen waar onze serviceproviders actief zijn.',
      p2: 'Door onze service te gebruiken, stem je in met de overdracht van je informatie naar landen buiten je woonland, die mogelijk andere gegevensbeschermingswetten hebben.',
    },

    changes: {
      title: 'Wijzigingen in dit privacybeleid',
      description: 'We kunnen dit privacybeleid van tijd tot tijd bijwerken. We zullen je op de hoogte brengen van eventuele wijzigingen door het nieuwe privacybeleid op deze pagina te plaatsen en de datum "Laatst bijgewerkt" bij te werken. Significante wijzigingen zullen worden gecommuniceerd via e-mail of een prominente kennisgeving op onze website.',
    },

    contact: {
      title: 'Neem contact met ons op',
      description: 'Als je vragen, zorgen of verzoeken hebt met betrekking tot dit privacybeleid of onze gegevenspraktijken, neem dan contact met ons op:',
      email: 'E-mail:',
      company: 'Bedrijf:',
    },

    cookieConsent: {
      title: 'Cookie Consent & Control',
      p1: 'We believe in transparency and giving you control over your data. When you first visit Zodiac Chess, you will be presented with a cookie consent banner that allows you to choose which types of cookies you want to accept.',
      categories: {
        title: 'Cookie Categories',
        necessary: {
          title: 'Necessary Cookies',
          description: ' These cookies are essential for the website to function properly. They enable core features like authentication, game state management, and security. You cannot opt out of these cookies.',
        },
        analytics: {
          title: 'Analytics Cookies',
          description: ' These cookies help us understand how visitors interact with our website by collecting anonymous usage data through Firebase Analytics. This helps us improve the game experience.',
        },
        advertising: {
          title: 'Advertising Cookies',
          description: ' These cookies are used by Google AdSense to display personalized advertisements. Premium members never see ads, regardless of consent settings.',
        },
      },
      control: {
        title: 'How to Control Cookies',
        p1: 'You have several options to manage your cookie preferences:',
        method1: 'Cookie Banner: On your first visit, you can accept all cookies, reject optional cookies, or customize your preferences.',
        method2: 'Browser Settings: Most browsers allow you to refuse or delete cookies through their settings menu.',
        method3: 'Opt-Out Links: For advertising cookies, you can opt out of personalized ads using the links below.',
      },
      optOut: {
        title: 'Opt Out of Personalized Advertising',
        p1: 'If you would like to opt out of personalized advertising from Google and other ad networks, you can use these resources:',
        googleAds: 'Google Ad Settings - Manage Google personalized ads',
        daa: 'Digital Advertising Alliance (DAA) - Opt out of interest-based ads',
        eaa: 'European Interactive Digital Advertising Alliance (EDAA) - EU users opt-out',
      },
      moreInfo: 'For more detailed information about the cookies we use, please visit our',
      cookiePolicyLink: 'Cookie Policy',
    },
  },

  // Cookie Consent Banner
  cookieConsentBanner: {
    title: 'We Value Your Privacy',
    description: 'We use cookies to enhance your experience, analyze site usage, and show personalized ads (for free users only). You can customize your preferences at any time.',
    acceptAll: 'Accept All',
    rejectAll: 'Reject Optional',
    customize: 'Customize',
    savePreferences: 'Save Preferences',
    back: 'Back',
    necessary: 'Necessary Cookies',
    necessaryDesc: 'Required for the site to function. These cannot be disabled.',
    analytics: 'Analytics Cookies',
    analyticsDesc: 'Help us understand how you use the site to improve your experience.',
    advertising: 'Advertising Cookies',
    advertisingDesc: 'Used to show personalized ads (free users only, premium members never see ads).',
    privacyPolicy: 'Privacy Policy',
    cookiePolicy: 'Cookie Policy',
  },

  // Terms of Service
  terms: {
    title: 'Servicevoorwaarden',
    lastUpdated: 'Laatst Bijgewerkt',
    back: 'Terug',
    viewPrivacyPolicy: 'Bekijk Privacybeleid',
    acknowledgment: 'Door Zodiac Chess te gebruiken, erkent u dat u deze Servicevoorwaarden hebt gelezen, begrepen en ermee akkoord gaat eraan gebonden te zijn.',
    acceptance: {
      title: '1. Aanvaarding van Voorwaarden',
      p1: 'Door toegang te krijgen tot en gebruik te maken van Zodiac Chess (de "Service"), aanvaardt u en stemt u ermee in gebonden te zijn aan deze Servicevoorwaarden. Als u niet akkoord gaat met deze voorwaarden, gebruik de Service dan niet.',
      p2: 'Wij behouden ons het recht voor om deze voorwaarden op elk moment te wijzigen. Voortgezet gebruik van de Service na wijzigingen vormt aanvaarding van de gewijzigde voorwaarden.',
    },
    description: {
      title: '2. Beschrijving van de Service',
      p1: 'Zodiac Chess is een online strategisch bordspel met unieke dierenstukken met speciale vaardigheden. De Service omvat:',
      feature1: 'Singleplayer gameplay tegen AI-tegenstanders',
      feature2: 'Multiplayer matchmaking en competitief spel',
      feature3: 'Interactieve tutorials en leermiddelen',
      feature4: 'Accountcreatie en voortgangsregistratie',
      feature5: 'Optionele premium abonnementsfuncties',
      feature6: 'Cosmetische aanpassingsopties',
    },
    accounts: {
      title: '3. Gebruikersaccounts',
      eligibility: {
        title: '3.1 Geschiktheid',
        p1: 'U moet minimaal 13 jaar oud zijn om een account aan te maken. Gebruikers jonger dan 13 jaar mogen de gastmodus gebruiken onder ouderlijk toezicht, maar kunnen geen accounts aanmaken.',
      },
      responsibilities: {
        title: '3.2 Accountbeveiliging',
        p1: 'U bent verantwoordelijk voor:',
        item1: 'Het handhaven van de vertrouwelijkheid van uw wachtwoord',
        item2: 'Alle activiteiten die onder uw account plaatsvinden',
        item3: 'Ons onmiddellijk op de hoogte stellen van ongeautoriseerd gebruik',
        p2: 'Wij zijn niet aansprakelijk voor verlies of schade als gevolg van ongeautoriseerde accounttoegang.',
      },
      prohibited: {
        title: '3.3 Verboden Activiteiten',
        p1: 'U mag NIET:',
        item1: 'Uw account delen met anderen',
        item2: 'Meerdere accounts gebruiken om rankings te manipuleren',
        item3: 'Bots, scripts of geautomatiseerde tools gebruiken om te spelen',
        item4: 'Andere spelers lastigvallen, misbruiken of bedreigen',
        item5: 'Bugs of glitches misbruiken voor oneerlijk voordeel',
        item6: 'Reverse engineering toepassen of proberen toegang te krijgen tot onze broncode',
        p2: 'Overtreding van deze regels kan leiden tot accountopschorting of permanente verbanning.',
      },
    },
    premium: {
      title: '4. Premium Abonnementen',
      billing: {
        title: '4.1 Facturering',
        p1: 'Premium abonnementen worden verwerkt via Stripe. Door een premium abonnement aan te schaffen, machtigt u ons om uw betaalmethode op terugkerende basis te belasten tot u opzegt.',
        p2: 'Abonnementskosten zijn:',
        item1: 'Maandelijks Plan: Maandelijks gefactureerd op de verjaardag van uw aankoopdatum',
        item2: 'Jaarlijks Plan: Jaarlijks gefactureerd op de verjaardag van uw aankoopdatum',
        p3: 'Prijzen kunnen worden gewijzigd met 30 dagen kennisgeving aan actieve abonnees.',
      },
      cancellation: {
        title: '4.2 Annulering',
        p1: 'U kunt uw abonnement op elk moment opzeggen via uw accountinstellingen of door contact op te nemen met ondersteuning. Annulering gaat in aan het einde van uw huidige factureringsperiode.',
        p2: 'U behoudt premium functies tot het einde van uw betaalde periode, zelfs na annulering.',
      },
      refunds: {
        title: '4.3 Terugbetalingen',
        p1: 'Maandelijkse abonnementen: Geen terugbetaling voor gedeeltelijke maanden. Annuleer op elk moment om toekomstige kosten te stoppen.',
        p2: 'Jaarlijkse abonnementen: Volledige terugbetaling indien aangevraagd binnen 7 dagen na aankoop. Na 7 dagen zijn terugbetalingen naar ons goeddunken.',
        p3: 'Cosmetische aankopen: Over het algemeen niet restitueerbaar. Neem contact op met ondersteuning voor uitzonderlijke omstandigheden.',
      },
    },
    acceptable: {
      title: '5. Beleid voor Aanvaardbaar Gebruik',
      p1: 'U stemt ermee in Zodiac Chess op een respectvolle en wettige manier te gebruiken. Verboden gedrag omvat:',
      item1: 'Valsspelen, hacken of misbruiken van spelmechanismen',
      item2: 'Intimidatie, haatzaaien of discriminerende taal',
      item3: 'Spammen, adverteren of werving',
      item4: 'Ongepaste content delen (als chat of door gebruikers gegenereerde content is ingeschakeld)',
      item5: 'Zich voordoen als andere gebruikers of personeelsleden',
      item6: 'Proberen de Service te verstoren of te beschadigen',
      p2: 'Wij behouden ons het recht voor om overtredingen te onderzoeken en passende maatregelen te nemen, inclusief accountbeëindiging en melding aan autoriteiten indien nodig.',
    },
    intellectual: {
      title: '6. Intellectuele Eigendomsrechten',
      ownership: {
        title: '6.1 Onze Content',
        p1: 'Alle spelcontent, inclusief maar niet beperkt tot spelmechanismen, artwork, animaties, geluidseffecten, code en ontwerp, zijn eigendom van Animal Chess Limited of onze licentiegevers.',
        p2: 'U krijgt een beperkte, niet-exclusieve, niet-overdraagbare licentie om de Service uitsluitend voor persoonlijke entertainmentdoeleinden te gebruiken.',
      },
      userContent: {
        title: '6.2 Gebruikerscontent',
        p1: 'Door content in te dienen (zoals chatberichten, gebruikersnamen of profielinformatie), verleent u ons een wereldwijde, royaltyvrije licentie om die content te gebruiken, weer te geven en te distribueren in verband met de Service.',
        p2: 'U verklaart dat u de eigenaar bent of de benodigde rechten hebt op alle content die u indient.',
      },
    },
    disclaimers: {
      title: '7. Disclaimers en Beperkingen van Aansprakelijkheid',
      p1: 'DE SERVICE WORDT GELEVERD "ZOALS HIJ IS" ZONDER GARANTIES VAN WELKE AARD DAN OOK, EXPLICIET OF IMPLICIET.',
      p2: 'Wij garanderen niet dat:',
      item1: 'De Service ononderbroken of foutloos zal zijn',
      item2: 'Defecten zullen worden gecorrigeerd',
      item3: 'De Service vrij is van virussen of schadelijke componenten',
      item4: 'Resultaten van het gebruik van de Service aan uw verwachtingen zullen voldoen',
      p3: 'VOOR ZOVER MAXIMAAL TOEGESTAAN DOOR DE WET, ZIJN WIJ NIET AANSPRAKELIJK VOOR:',
      item5: 'Enige indirecte, incidentele of gevolgschade',
      item6: 'Verlies van winst, gegevens of goodwill',
      item7: 'Serviceonderbrekingen of gegevensverlies',
      item8: 'Schade die het bedrag overschrijdt dat u ons in de afgelopen 12 maanden hebt betaald',
    },
    privacy: {
      title: '8. Privacy',
      p1: 'Uw gebruik van de Service wordt ook beheerst door ons Privacybeleid, dat uitlegt hoe wij uw persoonlijke informatie verzamelen, gebruiken en beschermen.',
      p2: 'Door de Service te gebruiken, stemt u in met onze gegevenspraktijken zoals beschreven in het Privacybeleid.',
    },
    changes: {
      title: '9. Wijzigingen in Voorwaarden',
      p1: 'Wij behouden ons het recht voor om deze Servicevoorwaarden op elk moment te wijzigen. Wij zullen gebruikers op de hoogte stellen van materiële wijzigingen via:',
      item1: 'E-mailnotificatie aan geregistreerde gebruikers',
      item2: 'Prominente kennisgeving op de website',
      item3: 'Bijgewerkte "Laatst Bijgewerkt" datum bovenaan deze pagina',
      p2: 'Uw voortgezet gebruik van de Service na wijzigingen vormt aanvaarding van de gewijzigde voorwaarden.',
    },
    governing: {
      title: '10. Toepasselijk Recht',
      p1: 'Deze Servicevoorwaarden worden beheerst door de wetten van Nieuw-Zeeland, zonder rekening te houden met beginselen van wetsconflicten.',
      p2: 'Alle geschillen die voortvloeien uit deze voorwaarden of uw gebruik van de Service zullen worden beslecht in de rechtbanken van Nieuw-Zeeland.',
    },
    contact: {
      title: '11. Contactgegevens',
      p1: 'Voor vragen, zorgen of ondersteuning met betrekking tot deze Servicevoorwaarden:',
      email: 'E-mail:',
      company: 'Bedrijf:',
      address: 'Adres:',
    },
    severability: {
      title: '12. Scheidbaarheid',
      p1: 'Als een bepaling van deze voorwaarden niet-afdwingbaar of ongeldig wordt bevonden, zal die bepaling worden beperkt of geëlimineerd tot het minimaal noodzakelijke, en blijven de overige bepalingen volledig van kracht.',
    },
  },

  // Cookie Policy
  cookiePolicy: {
    title: 'Cookiebeleid',
    lastUpdated: 'Laatst Bijgewerkt',
    browserInstructions: {
      chrome: 'Instellingen → Privacy en beveiliging → Cookies',
      firefox: 'Instellingen → Privacy en beveiliging → Cookies en sitegegevens',
      safari: 'Voorkeuren → Privacy → Cookies en websitegegevens',
      edge: 'Instellingen → Privacy, zoeken en services → Cookies',
    },
    cookieTable: {
      name: 'Cookienaam',
      purpose: 'Doel',
      duration: 'Duur',
      type: 'Type',
    },
    relatedPolicies: {
      title: 'Gerelateerd Beleid',
      description: 'Voor meer informatie over hoe wij uw gegevens verwerken, zie:',
      privacy: 'Privacybeleid',
      terms: 'Servicevoorwaarden',
    },

    introduction: {
      title: 'Inleiding',
      p1: 'Dit Cookiebeleid legt uit hoe Zodiac Chess ("wij", "ons" of "onze") cookies en vergelijkbare technologieën gebruikt wanneer u onze website bezoekt.',
      p2: 'Door onze website te gebruiken, stemt u in met ons gebruik van cookies in overeenstemming met dit beleid. Als u niet akkoord gaat, schakel dan cookies uit in uw browserinstellingen of gebruik onze website niet.',
    },
    what: {
      title: 'Wat Zijn Cookies?',
      p1: 'Cookies zijn kleine tekstbestanden die op uw apparaat (computer, smartphone, tablet) worden geplaatst wanneer u een website bezoekt. Ze worden veel gebruikt om websites efficiënt te laten werken en om informatie te verstrekken aan website-eigenaren.',
      p2: 'Cookies dienen verschillende doeleinden, waaronder het onthouden van uw voorkeuren, het analyseren van sitegebruik en het mogelijk maken van bepaalde functies.',
    },
    types: {
      title: 'Soorten Cookies die Wij Gebruiken',
      necessary: {
        title: '1. Noodzakelijke Cookies',
        description: 'Deze cookies zijn essentieel voor het goed functioneren van de website. Zonder deze cookies kunnen de door u gevraagde diensten niet worden geleverd.',
        examples: 'Voorbeelden:',
        item1: 'Authenticatiecookies - Houden u ingelogd op uw account',
        item2: 'Beveiligingscookies - Beschermen tegen frauduleuze activiteiten',
        item3: 'Sessiecookies - Behouden uw spelstatus tijdens een sessie',
        item4: 'Cookie-toestemmingsvoorkeuren - Onthouden uw cookiekeuzes',
      },
      analytics: {
        title: '2. Analytische Cookies',
        description: 'Deze cookies helpen ons te begrijpen hoe bezoekers omgaan met onze website door anonieme informatie te verzamelen over paginabezoeken, bestede tijd en gebruikte functies.',
        provider: 'Aanbieder: Firebase Analytics (Google)',
        purpose: 'Doel:',
        item1: 'Websiteverkeer en gebruikersbetrokkenheid meten',
        item2: 'Populaire functies en pagina\'s identificeren',
        item3: 'Gebruikersdemografie begrijpen (leeftijdsbereik, algemene locatie)',
        item4: 'Websiteprestaties en gebruikerservaring verbeteren',
      },
      advertising: {
        title: '3. Advertentiecookies',
        description: 'Deze cookies worden gebruikt om advertenties weer te geven die relevant voor u zijn. Ze beperken ook het aantal keren dat u een advertentie ziet en helpen de effectiviteit van advertentiecampagnes te meten.',
        provider: 'Aanbieder: Google AdSense',
        purpose: 'Doel:',
        item1: 'Gepersonaliseerde advertenties tonen op basis van uw interesses',
        item2: 'Advertentieprestaties en betrokkenheid meten',
        item3: 'Voorkomen dat dezelfde advertentie te vaak wordt getoond',
        note: 'Opmerking: Premium-abonnees zien nooit advertenties, ongeacht cookie-instellingen.',
      },
    },
    firstThird: {
      title: 'First-Party vs Third-Party Cookies',
      firstParty: {
        title: 'First-Party Cookies',
        description: 'Dit zijn cookies die rechtstreeks door Zodiac Chess worden ingesteld. We gebruiken ze voor essentiële sitefunctionaliteit, authenticatie en het onthouden van uw voorkeuren.',
      },
      thirdParty: {
        title: 'Third-Party Cookies',
        description: 'Dit zijn cookies die worden ingesteld door externe diensten die wij gebruiken, zoals Google Analytics en Google AdSense. Third-party cookies zijn onderworpen aan het privacybeleid van die aanbieders.',
      },
    },
    specific: {
      title: 'Specifieke Cookies die Wij Gebruiken',
      tableHeader: 'Hieronder vindt u een gedetailleerde lijst van de cookies die op onze website worden gebruikt:',
    },
    control: {
      title: 'Hoe Cookies te Beheren',
      consent: {
        title: '1. Cookie-toestemmingsbanner',
        description: 'Wanneer u onze website voor het eerst bezoekt, ziet u een cookie-toestemmingsbanner. U kunt:',
        item1: 'Alles Accepteren - Alle cookies toestaan (noodzakelijk, analytisch en reclame)',
        item2: 'Optionele Weigeren - Alleen noodzakelijke cookies toestaan (geen analytics of advertenties)',
        item3: 'Aanpassen - Precies kiezen welke soorten cookies u wilt toestaan',
      },
      browser: {
        title: '2. Browserinstellingen',
        description: 'De meeste webbrowsers stellen u in staat cookies te beheren via hun instellingen. U kunt:',
        item1: 'Alle cookies blokkeren',
        item2: 'Alleen first-party cookies accepteren',
        item3: 'Cookies verwijderen na elke browsersessie',
        item4: 'Individuele cookies bekijken en verwijderen',
        links: 'Hier zijn links naar cookiebeheer voor populaire browsers:',
      },
      optOut: {
        title: '3. Opt-Out Tools',
        description: 'Specifiek voor advertentiecookies kunt u afmelden voor gepersonaliseerde advertenties:',
        googleLink: 'Google Advertentie-instellingen',
        googleDesc: ' - Beheer Google gepersonaliseerde advertenties',
        daaLink: 'Digital Advertising Alliance (DAA)',
        daaDesc: ' - Afmelden voor op interesses gebaseerde advertenties',
        edaaLink: 'European Interactive Digital Advertising Alliance (EDAA)',
        edaaDesc: ' - EU-specifieke opt-out tool',
      },
    },
    impact: {
      title: 'Impact van het Uitschakelen van Cookies',
      p1: 'Als u cookies uitschakelt of weigert, let dan op het volgende:',
      item1: 'Sommige delen van de website werken mogelijk niet goed',
      item2: 'U moet mogelijk uw voorkeuren bij elk bezoek opnieuw invoeren',
      item3: 'U kunt worden uitgelogd van uw account',
      item4: 'Noodzakelijke cookies zijn vereist voor de werking van de site - het uitschakelen ervan voorkomt dat u kernfuncties gebruikt',
    },
    updates: {
      title: 'Updates van dit Cookiebeleid',
      p1: 'Wij kunnen dit Cookiebeleid van tijd tot tijd bijwerken om veranderingen in onze praktijken weer te geven of om juridische, regelgevende of operationele redenen.',
      p2: 'Wij zullen u op de hoogte stellen van belangrijke wijzigingen door de datum "Laatst Bijgewerkt" bovenaan deze pagina bij te werken. Bekijk dit beleid regelmatig.',
    },
    contact: {
      title: 'Neem Contact Op',
      p1: 'Als u vragen heeft over ons gebruik van cookies of dit Cookiebeleid, neem dan contact met ons op:',
      email: 'E-mail:',
      company: 'Bedrijf:',
    },
  },

  // Game
  game: {
    yourTurn: 'Your Turn',
    opponentTurn: "Opponent's Turn",
    victory: 'Victory!',
    defeat: 'Defeat',
    draw: 'Draw',
    resign: 'Resign',
    offerDraw: 'Offer Draw',
  },

  // Game Info
  gameInfo: {
    title: 'Game Info',
    sandboxMode: 'Sandbox Mode',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
    yourTurn: 'Your turn',
    opponentTurn: "Opponent's turn",
    aiThinking: 'AI thinking...',

    // Selection states
    selecting: 'Selecting {piece}',
    observing: 'Observing {piece}',
    selectingZombified: 'Selecting zombified enemy {piece}',
    selectionLocked: 'Selection locked on {piece}',
    selectionLockedPenguin: 'Pinguïn',

    // Hints
    clickToFaint: 'Click on {piece} to faint',
    clickToRotate: 'Click on the {piece} to rotate',
    clickToInk: 'Click on the {piece} to ink',
    zombifiedWarning: '⚠️ While zombified, {piece} rotates before moving!',

    // Monkey bonus turn
    monkeySwing: 'Monkey completed swing, please move your Monkey to complete bonus turn',
    monkeyConsume: 'Monkey consumed fungi, please move your Monkey to complete bonus turn',

    // Virus bonus turn
    virusInfecting: 'Virus is infecting, continue turn or click on virus to end turn',

    // Penguin bonus turn
    penguinRotate: 'Penguin completed slide - please choose final rotation direction',
    penguinCaptureRotate: 'Penguin completed capture - please choose final rotation direction',
    penguinZombified: 'Zombified Penguin rotated - complete turn with slide/capture (zombification will end)',

    // Capture restrictions
    cannotCapture: '{piece} cannot capture: {targets}',
    cannotInfect: '{piece} cannot infect: {targets}',
    cannotEntangle: '{piece} cannot entangle: {targets}',
    monkeyBearRoll: '{piece} must roll 5-6 to capture enemy {target}',
    cannotBeCapturedBy: '{piece} cannot be captured by: {attackers}',
    monkeyNeedsRoll: '{attacker} needs to roll 5-6 to capture',
  },

  // Piece names
  pieces: {
    Bear: 'Beer',
    Crane: 'Kraanvogel',
    Frog: 'Kikker',
    Fungi: 'Paddenstoel',
    Goat: 'Geit',
    Monkey: 'Aap',
    Octopus: 'Octopus',
    Penguin: 'Pinguïn',
    Rhino: 'Neushoorn',
    Snake: 'Slang',
    Tree: 'Boom',
    Virus: 'Virus',
    Wolf: 'Wolf',
  },


  // Move Context (piece descriptions)
  moveContext: {
    title: 'Move Context',
    emptyState: 'Select an ability from the left panel to view detailed information.',
  },

  // Challenge AI
  challengeAI: {
    // Title and tagline
    title: 'AI ARENA',
    tagline: 'Pick an AI to Battle or watch AI duke it out!',

    // Player labels
    lightPlayer: 'Light Player',
    darkPlayer: 'Dark Player',
    humanPlayer: 'Human Player',

    // AI Models
    aiGaia: 'Gaia',
    aiSentinel: 'Sentinel',
    aiAlchemist: 'Alchemist',
    aiZenith: 'Zenith',
    aiTrapper: 'Trapper',
    aiHunter: 'Hunter',
    aiWisp: 'Wisp',
    aiCreature: 'Creature',
    aiWeaver: 'Weaver',

    // Time Frames
    timeFast: 'Fast',
    timeStandard: 'Standard',
    timeDeep: 'Deep',

    // Thinking time
    thinkingTime: 'Thinking Time',

    // Info box
    matchupLabel: 'Matchup:',
    statusLabel: 'Status:',
    statusPaused: 'PAUSED',
    statusAIThinking: 'AI Thinking...',
    statusInGame: 'In Game',
    statusReady: 'Ready',
    matchupLocal2P: 'Local 2P',
    matchupPlayerVs: 'Player vs',
    matchupVsPlayer: 'vs Player',

    // Buttons
    startButton: 'Start',
    startRandomButton: 'Start Random',
    newGameButton: 'New Game',
    resumeButton: 'Resume',
    pauseButton: 'Pause',
    pauseQueuedButton: 'Pause (queued...)',
    viewKingsButton: 'View Kings',
    hideKingsButton: 'Hide Kings',
    viewKingsQueuedButton: 'View Kings (queued...)',
    hideKingsQueuedButton: 'Hide Kings (queued...)',
    homeButton: 'Home',
    toggleKingVisibility: 'Toggle king visibility',

    // Warning modal
    invalidPlacement: 'Invalid Placement',
    okButton: 'OK',
    warningLightTurn: "It's Light player's turn to place a piece!",
    warningDarkTurn: "It's Dark player's turn to place a piece!",
    warningLightRow: 'Light pieces must be placed on row 0 (your home row)!',
    warningDarkRow: 'Dark pieces must be placed on row 7 (your home row)!',
    warningOccupied: 'This square is already occupied! Choose an empty square.',
    warningKingRequired: 'You must place your king ({kingType}) before placing your 5th piece!',

    // Piece selection
    dragPieces: 'Drag pieces to the board',
    lightPieces: 'Light Pieces',
    darkPieces: 'Dark Pieces',

    // Mobile
    selectYourKing: 'Select Your King',
    selectPieceToPlace: 'Select Piece to Place',
    moveHistory: 'Move History',
    historyButton: 'History',
    backButton: 'Back',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
  },

  // Donation
  donation: {
    title: 'Support Zodiac Chess',
    supportDevelopment: 'Support Development',
    story1: "Hi! Your support helps me continue improving this unique game! Adding new features, maintaining servers, and keeping Zodiac Chess free for the community.",
    story2: "Even a small donation makes a huge difference and keeps this project alive. Thank you for being part of the Zodiac Chess journey :)",
    selectAmount: 'Choose Amount',
    customAmount: 'Or enter custom amount:',
    total: 'Total:',
    donateButton: 'Donate Now',
    processing: 'Processing...',
    disclaimer: 'Donations support development and server costs. Thank you for your generosity!',
    invalidAmount: 'Please enter a valid amount greater than $0',
    error: 'There was an error processing your donation. Please try again.',
  },

  // Game End Popup
  gameEnd: {
    victory: 'VICTORY!',
    defeat: 'DEFEAT!',
    draw: 'DRAW!',
    wonBy: 'Won by {condition}',
    lostBy: 'Lost by {condition}',
    drawBy: 'Draw by {condition}',
    conditions: {
      kingslayer: 'Kingslayer',
      race: 'Race Victory',
      timeout: 'Timeout',
      threefold: '3x Repetition',
      noMoves: 'No Valid Moves',
      draw: 'Draw',
    },
  },

  // Upgrade Modal
  upgrade: {
    title: 'Upgrade to Premium',
    accountRequired: 'You need to create a permanent account before upgrading to premium.',
    createAccountPrompt: 'Create an account to save your progress and unlock premium features!',
    subtitle: 'Unlock powerful features to enhance your Zodiac Chess experience!',
    features: {
      history: 'Account History',
      historyItem1: 'Store and recall all your previous games',
      historyItem2: 'Replay your old games from anypoint to evaluate strategy',
      historyItem3: 'Use deep analytics to analyse board positions and brilliant move opportunities',
      analytics: 'Analytics',
      analyticsItem1: 'Get access to game stats',
      analyticsItem2: 'Analyse users piece and king selection across tonnes of metrics',
      analyticsItem3: 'Find out what metas are popular and whats working!',
      course: 'Course',
      courseItem1: 'Get access to upto date courses to develop your skill',
      courseItem2: "Learn meta's and concepts from the pro's",
      courseItem3: 'Get tips on your own game play to analyse your own weaknesses',
    },
    createAccount: 'Create Account',
    upgradeNow: 'Upgrade Now',
    cancel: 'Cancel',
  },

  // Premium Modal
  premium: {
    title: 'Premium Feature',
    accessDenied: 'Sorry you do not have a premium account, you do not have access to these features yet!',
  },

  // Stripe Error Page
  stripe: {
    errorTitle: 'Oops! Something Went Wrong',
    errorMessage: "We encountered an issue processing your payment. Don't worry, you haven't been charged.",
    whatHappened: 'What happened?',
    notCompleted: "Your payment wasn't completed. This could be due to:",
    reasons: {
      cancelled: 'Payment was cancelled',
      declined: 'Card was declined',
      connection: 'Connection issue during checkout',
      expired: 'Session expired',
    },
    whatToDo: 'What can you do?',
    actions: {
      tryDifferentCard: 'Try again with a different card',
      tryDifferentCardDesc: 'Use another payment method',
      retryPayment: 'Retry the payment',
      retryPaymentDesc: 'Sometimes a simple retry works',
      checkBank: 'Check with your bank',
      checkBankDesc: 'Ensure your card has sufficient funds',
    },
    tryAgain: 'Try Upgrading Again',
    returnHome: 'Return to Main Page',
    contactSupport: 'Need help? Contact support at support@zodiac-chess.com',
  },


  // How To Play - Learn the Pieces
  howToPlay: {
    // Section titles
    whatIsZodiac: 'What is it about?',
    gameSetup: 'Game Setup',
    basicRules: 'Basic Rules',
    backButton: 'BACK',
    homeButton: 'Home',
    fullRules: 'Full Rules',

    // What is Zodiac section
    whatIs: {
      p1: 'Zodiac is a two player abstract strategy game based off of Chess, Poker and DotA.',
      p2: 'It was created in 2014 as a crude version of itself called "Shadow Chess" based off its central principal of a secret king',
      p3: 'Later in 2018 it was redesigned to involve a roster of novel pieces with unique movement patterns and abilities',
      p4: "Zodiac's goal is to celebrate human intuition and novel play. To drive success toward a players ability to bluff and adapt to unfamiliar situations and create a nuanced set of challenges for the ever growing strength of AI",
      p5: "Another goal of Zodiac is to be a game for humans! With a very large search space for play, hidden information, win obfuscation and a changing roster of pieces over time. Zodiac wants to be a player data driven game that keeps creativity mainstay and staves off AI dominance",
      p6: 'We hope you stick around and see where this journey takes us',
    },

    // Setup section
    setup: {
      p1: "Players play a zodiac version of paper, scissors, rock to see who goes first!",
      p2: 'From there, select a piece to be your "King" your opponent won\'t know which one you have chosen.',
      p3: 'Then pick 5 pieces to play with, they all have different abilities, cohesion, strengths and weaknesses!',
      p4: 'Once you are both done the game will begin.',
      p5: 'Simply click on a piece to see where it can move to or click on any unhighlighted square to deselect the piece.',
      p6: 'Good luck!',
    },

    // Basic Rules section
    rules: {
      intro: 'The game of Zodiac is played by two players on a rectangle board made up of 40 squares (5 by 8).',
      toWinTitle: 'To win:',
      toWin1: 'Capture the opponents King',
      toWin2: '"Race" your King across the board',
      toWin3: 'Have your opponents timer expire',
      toWin4: 'Have your opponent surrender',
      drawTitle: 'A draw occurs',
      draw1: 'When a players king is still uncaptured and they cannot make any legal move, or;',
      draw2: 'The same board position is repeated three times',
    },

    // Piece tutorials
    tutorials: {
      bear: {
        desc1: 'Regular movement - The Bear can move one square in any direction',
        desc2: 'The Bear\'s ability "Savage" allows it to capture any piece regardless of defensive abilities',
        desc3: 'The bear is a "large" piece and a "predator" piece meaning many of the other Zodiacs cannot capture it!',
      },
      crane: {
        desc1: 'The Crane can move 1 or 2 in any straight line for its regular movement',
        desc2: "The Crane cannot capture any 'large' or 'predator' pieces",
      },
      frog: {
        desc1: 'The frog can jump 2 on diagonals for its regular movement, even over other pieces!',
        desc2: "If the frog's regular movement is blocked by a wall or a piece it cannot capture, its regular movement is shortened to 1 square diagonally",
        desc3: "If the frog has yet to make a move in the game, it is on its 'lily pad' and can move to any of the first 3 ranks as a defensive movement",
        desc4: 'If a piece captures a frog, it becomes poisoned and cannot make any move for its next available turn',
        desc5: "The frogs special movement is 'wall climb' if a frog is beside the edge of the board, it can also move one up or down",
      },
      fungi: {
        desc1: 'The Fungi can move one in any direction for its regular movement',
        desc2: "The fungi's ability 'meadow' prevents a tree from moving if it is within one square of the fungi and does not allow a tree to move within one square of the enemy fungi",
        desc3: "When captured the fungi applies a 'zombie' effect to any animal piece that captured it",
        desc4: 'While zombified, the fungi controls the piece for the following turn and acts as the piece, meaning if the fungi was your king, you can still win by race victory or capturing the enemy king within that round',
      },
      goat: {
        desc1: 'The goat can move one in any direction for its regular movement',
        desc2: "The goats ability 'traverse' allows it to hop across linked pieces and then move, it cannot capture any piece on a traverse",
        desc3: "The goat cannot capture any 'predators'",
        desc4: "The goat can use a special ability called 'faint' to make itself appear dead",
        desc5: "While fainted, the goat is unable to be captured by most pieces but cannot move if another piece is 'standing' on it (on the same square)",
      },
      monkey: {
        desc1: 'The monkey can move one in any direction for its regular movement',
        desc2: "The monkey can 'leap' over friendly and enemy pieces like a checkers piece if the formation allows it",
        desc3: 'If the monkey does leap over an enemy piece it must roll a dice to not be captured! One danger point per enemy piece it leaps in a single line',
        desc4: 'The monkey CAN capture a bear if it decides to gamble to attack it, on a 1-4 roll on a six sided dice, the Monkey is captured, on a 5 or 6, the Monkey captures the bear',
        desc5: "The monkey has two abilities - 'swing' and 'consume' on a swing (a leap ending over a tree) the monkey gains an extra movement, on a consume of any fungi, the monkey also gains one extra movement before its turns end",
      },
      octopus: {
        desc1: 'The octopus can move one in any direction for its regular movement',
        desc2: 'The octopus may only capture on orthagonal squares',
        desc3: "The octopus can use its ability 'entangle' on any animal piece on diagonal squares",
        desc4: 'The octopus may make any move AND entangle in one turn',
        desc5: "The octopus has an ability called 'ink' with this ability it can move to any orthagonal square and place 'shadows' on the other 3 orthagonal squares if they are not occupied or off of the board. To the opponent for the round following the 'ink' ability the shadows and real octopus are indistinguishable",
      },
      penguin: {
        desc1: "The penguin has an ability called 'rotate' it is the only piece that has a set direction and may use the 'rotate' move to redirect its direction for its turn",
        desc2: "For the penguins regular movement 'slide' it must move to the furthest point in the direction it is facing and once there, it may use a rotate before its turns end to redirect its direction",
        desc3: "The penguin cannot capture any 'large' or 'predator' pieces. It can capture any other piece within one square of itself and use a rotate ability after the capture",
      },
      rhino: {
        desc1: "The rhino can move 'back left', 'back right' or two forward as part of its regular movement",
        desc2: "The rhino has an ability called 'trample' where captures ALL pieces in the path of its movement",
        desc3: 'Once per game a rhino may perform a charge of 3 squares ahead if any animal is present in any of the 3 squares directly infront of the rhino',
        desc4: 'The rhino has a special ability called "rhino defence" where the rhino cannot be captured from \'the front\'',
        desc5: "The rhino has an ability called 'lane' where if it has not moved and the friendly piece directly to its left or right has not moved, it can switch places with that piece for its turn",
      },
      snake: {
        desc1: 'The snake can move 2 squares only in orthagonal directions, including through other pieces for its regular movement',
        desc2: 'If its regular movement is blocked by a wall or a piece it cannot capture, its regular movement becomes 1',
        desc3: 'The snake has an ability called "strike" where if an animal is exactly 3 squares ahead of it and there are no pieces between, it can \'strike\' forward and capture that animal',
        desc4: 'The snake has an ability called "shed" where once per game if the snake is captured, it will return to the first rank of the board, in the same column, as if it had a second life. If the first rank is not a valid square for the snake to move to, it is permanently captured',
      },
      tree: {
        desc1: 'The tree may move one forward or unlimitedly side to side if not blocked by any other piece',
        desc2: "The tree has a special ability called 'house' where any piece that can 'climb' tree's may sit on top of the tree piece. If an enemy piece attacks a tree with a housed piece, the housed piece is captured and the tree houses the enemy piece",
        desc3: 'When a piece is housed in the tree, if an enemy piece cannot climb the tree, both the tree and the housed piece are protected from capture',
      },
      wolf: {
        desc1: 'The wolf moves in an L shape like a knight in chess for its regular movement',
        desc2: "If the wolf is the last piece on the board* it's ability 'lone wolf' is activated and it moves in a long L instead as pictured above. *The wolf will enter lone if on a team with a fainted goat or infecting virus",
      },
      virus: {
        desc1: "The virus may move 2 squares in any straight line for its regular movement, it does not capture but uses its ability 'infect' to cause the piece to be infected rather than captured",
        desc2: "The virus can only move to any animal piece, if blocked by a wall, the virus's regular movement is only 1 square",
        desc3: "When an animal piece is 'infected' if the virus leaves the infected piece in to another piece, the piece it left is captured and the new piece is 'infected'",
        desc4: "The virus has an ability called 'infectious' which allows the virus to complete as many valid moves in one move as it likes, capturing multiple animals in one turn",
        desc5: "While not 'infecting' the virus can be captured like any other piece, if an animal captures an infected piece, it becomes infected",
      },
    },
  },
};
